import type { AreaInset, DeviceSafeArea } from '@hexa/app/platform/Platform';

export class WebSafeArea implements DeviceSafeArea {
  public async init(): Promise<void> {
    return Promise.resolve();
  }

  public getSafeAreaInset(): AreaInset {
    return { top: 0, right: 0, bottom: 0, left: 0 };
  }
}
